var _excluded = ["children", "icon", "dangerouslySetClassNames", "sizeVariant", "isActive"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { ListboxOption as ListboxOptionStyle, OptionIconWrapper } from "./styles";
import forwardRef from "../../private/forwardRef";
/**
 * A list item intended to be used alongside components with a listbox (Autocomplete, Select, etc.)
 */
var ListboxOption = forwardRef((_ref, externalRef) => {
  var {
      children,
      icon,
      dangerouslySetClassNames,
      sizeVariant = "large",
      isActive = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ListboxOptionStyle, _extends({
    ref: externalRef,
    $sizeVariant: sizeVariant,
    $isActive: isActive
  }, props), icon && /*#__PURE__*/React.createElement(OptionIconWrapper, {
    className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.iconWrapper
  }, icon), /*#__PURE__*/React.createElement("div", null, children));
});
ListboxOption.displayName = "ListboxOption";
export default ListboxOption;